const state = {
  dialogInteressado: false,
  dialogResponsavelTramitacao: false,
  tipoInteressado: undefined,
  interessado: undefined,
  tipoResponsavelTramitacao: undefined,
  responsavelTramitacao: undefined,
  listaEntidadeInteressada: [],
  listaEntidadeResponsavelTramitacao: [],
  listaTiposDocumento: [],
  listaTiposInteressado: [],
  listaInteressados: [],
  listaDocumentos: [],
  listaUnidadesProcedencia: [],
  buscandoDocumentos: false
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/busca-documentos/state.js